import { Store } from "../../../@core/store/store";


export class GetAllCategoriesLoadingState extends Store.AbstractLoadingState<any> { }
export class GetAllCategoriesLoadingErrorState extends Store.AbstractErrorState<any> { }
export class GetAllCategoriesLoadedState extends Store.AbstractIdealState<any> { }

export class pinAppLoadingState extends Store.AbstractLoadingState<any> { }
export class pinAppLoadingErrorState extends Store.AbstractErrorState<any> { }
export class pinAppLoadedState extends Store.AbstractIdealState<any> { }

export class UnPinAppLoadingState extends Store.AbstractLoadingState<any> { }
export class UnPinAppLoadingErrorState extends Store.AbstractErrorState<any> { }
export class UnPinAppLoadedState extends Store.AbstractIdealState<any> { }

export class addToRecentlyAccessedLoadingState extends Store.AbstractLoadingState<any> { }
export class addToRecentlyAccessedLoadingErrorState extends Store.AbstractErrorState<any> { }
export class addToRecentlyAccessedLoadedState extends Store.AbstractIdealState<any> { }

export class profileDataLoadingState extends Store.AbstractLoadingState<any> { }
export class profileDataLoadingErrorState extends Store.AbstractErrorState<any> { }
export class profileDataLoadedState extends Store.AbstractIdealState<any> { }

